export default {
    copyright: 'Copyright 2021 - AirClass Limited - All Rights Reserved',
    title: 'Log In',
    phone: 'Phone Number',
    psw: 'Password',
    forgot_psw: 'Forgot your password?',
    login: 'LOGIN',
    sign_up: 'Sign Up',
    or: 'or',
    text: `Don't have an AirClass account?`,
    createText: 'Create an account',
    codeText: 'Get the Code',
    text1: `Login with a password`,
    text2: `Login with a verification code`,
    sendText: 'Resend Code',
    sendText1: 'Request Again in',
    second: 's',
    code: 'Code',
    codeText1: `Check your phone for message with`,
    codeText2: 'a verification code：',
    required: 'Required',
    pwsText: `Password should be of at least 8 characters`,
    pwsText1: `Password should be of at most 20 characters`,
    pwsText2: `Password do not match`,
    pwsText4: `Re-enter Password`,
    failed: 'login failed',
    in: 'in',
    join: 'Join AirClass',
    descText: 'By joining, you agree to ',
    descText1: 'User Agreement ',
    descText2: 'and ',
    descText3: 'Privacy Policy ',
    descText4: 'Already have an account? ',
    loginText: 'Login',
    nameText: 'Your Name',
    age: 'Age',
    ageText: 'Your Age',
    sAge: 'Select Age',
    submit: 'Submit',
    create: 'Create Account',
    switch_mode: 'Login in with {mode}',
    information: 'Perfect Information',
		welcomeSpeech: 'Your friend invites you to join AirClass, register now and get a free trial lesson',
		createPrompt: 'Create with {type}',
		emailErr: 'You must enter a valid email address',
		hasEmail: 'The current email has been registered',
		unregistered: 'The current email has not been registered',
		existEmail: 'The email is already in use please try another',
		sentEmailBefore: 'The authorization code has been sent to ',
		sentEmailAfter: '. Please check your email.',
		getCode:'Get the Code',
		resendAgain:'Resend again in ',
		joinAirClass:'Join AirClass',
		esPhone:'Phone',
		resendCode:'Resend Code'
}
